import { controls, currencyToNumber, grouped } from "../../controls";

const rpsl16 = {
  label: "KCC SLBC",
  starting: true,
  url: "rpsl16",
  pageLabel: "KCC SLBC",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Reporting Season", star: true }),
    ...controls.autoComplete({ tab: "filter", name: "manual_report_master_code", width: "col-sm-2", controlType: "ManualReportMaster" }),
    ...controls.displayText({ tab: "filter", label: "" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "KCC SLBC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait"
    },
    textReportProps: {
      'slbc': {
        filename: `KCC.txt`,
        format: {},
        separator: "|"
      },
    },
   

    displayColumns: [
      {
        Header: "State Code",
        accessor: "slbc_state_no",

      },

      {
        Header: "District Code",
        accessor: "slbc_district_no",

      },
      {
        Header: "Block Code",
        accessor: "slbc_block_code",
      },
           
      {
        Header: "No.of KCC Issued During Qtr (including renewal) ",
        accessor: "no_of_kcc",
    
      },
      {
        Header: "Amount Disb. of KCC as on end of Current Qtr",
        accessor: "disbursed_amount",
        type: "currency"
      },
           
      {
        Header: "Total No of KCC As on End Of Current Qtr",
        accessor: "total_no_of_kcc",
    
      },
              
      {
        Header: "Outstanding as on End of current Qtr.",
        accessor: "outstanding_of_current_quarter",
        type: "currency"
      },

      {
        Header: "Out of TOTAL NO. OF KCC , Number of Rupay Card Issued",
        accessor: "out_of_total_no_of_kcc",
    
      },
      {
        Header: "KCC CARD ACTIVATED",
        accessor: "kCC_card_activated",
        type: "currency"
      },

    ]
  }
};

export default rpsl16;